<template lang="pug">
  .notification
    .notification__header
      .notification__title Ваш конструктор шкафов не настроен
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        | ConPlus настроен не полностью. Давайте попробуем ещё раз:
        br
        router-link.notification__link(
          @click.native="emitClick"
          title="Настройка"
          to="/settings"
        ) Начать настройку
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'ConstructorNotConfigured',
  mixins: [notification]
};
</script>
